<template>
  <div class="center--middle" id="centerMiddle"></div>
</template>

<script>
import { queryzcze } from '@/api/modules/dataView.js'
export default {
  name: 'CenterMiddle',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const zczeData = await queryzcze(this.date)
      const data_x = []
      const data_zcysze = []
      const data_zccgze = []
      const data_zczs = []
      zczeData.forEach(item => {
        data_x.push(item.hxcs_rksj || '')
        data_zcysze.push(item.hxcs_ysje || 0)
        data_zccgze.push(item.hxcs_htzj || 0)
        data_zczs.push(item.total || 0)
      })
      var chartDom = document.getElementById('centerMiddle')
      this.chart = this.$echarts.init(chartDom)
      var option

      option = {
        title: {
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          top: '30px',
          textStyle: {
            color: '#fff',
          },
          data: ['资产预算总额（元）', '资产采购总额（元）', '资产总数'],
        },
        grid: {
          top: 80,
          bottom: 40,
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: '#fff',
            },
            data: data_x,
          },
        ],
        yAxis: [
          {
            name: '金额（元）',
            nameTextStyle: {
              color: '#fff',
            },
            type: 'value',
            axisLabel: {
              color: '#fff',
            },
            boundaryGap: [0, 0.01],
          },
          {
            name: '数量',
            nameTextStyle: {
              color: '#fff',
            },
            type: 'value',
            axisLabel: {
              color: '#fff',
              formatter: '{value} 个',
            },
            boundaryGap: [0, 0.01],
          },
        ],
        series: [
          {
            name: '资产预算总额（元）',
            type: 'bar',
            data: data_zcysze,
          },
          {
            name: '资产采购总额（元）',
            type: 'bar',
            data: data_zccgze,
          },
          {
            name: '资产总数',
            type: 'line',
            yAxisIndex: 1,
            data: data_zczs,
          },
        ],
      }

      option && this.chart.setOption(option)
    },
  },
}
</script>

<style lang="scss">
.center--middle {
  width: 100%;
  height: 40%;
}
</style>
